export default __webpack_public_path__ + "360cbba450bc6fd883bfde9d3798fffe.svg";